import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1562577309-4932fdd64cd1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err, "Log masuk gagal")); } finally { setBusy(false); }
  };

  return (
    <div className="relative z-10 grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden lg:block">
        <img src={HERO} alt="Pemasaran media sosial" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/20" />
        <div className="absolute bottom-0 left-0 max-w-xl p-14">
          <p className="eyebrow !text-primary">Group & Page Facebook</p>
          <h1 className="mt-4 text-5xl font-extrabold leading-[1.05] tracking-tight">Satu tulisan.<br />Puluhan group.<br />Tanpa lupa.</h1>
          <p className="mt-5 text-base leading-relaxed text-slate-300">Jadualkan post, biar AI olah ayat untuk setiap group, dan terima peringatan tepat pada masanya.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="fade-up w-full max-w-sm" data-testid="login-form">
          <div className="mb-10 flex items-center gap-2.5">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary"><Send className="h-5 w-5 text-white" /></div>
            <p className="text-xl font-extrabold tracking-tight">PostPintar</p>
          </div>
          <h2 className="text-3xl font-bold tracking-tight">Log masuk</h2>
          <p className="mt-2 text-sm text-muted-foreground">Masuk ke ruang kerja automasi post anda.</p>
          <div className="mt-8 space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Emel</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-card" placeholder="anda@contoh.my" data-testid="login-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Kata laluan</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-card" data-testid="login-password-input" />
            </div>
            {error && <p className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="h-11 w-full text-sm font-semibold" data-testid="login-submit-btn">
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Log masuk
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
